import BsjSetDriverDetectionModal from './bsj-set-driver-detection-modal.vue'
export default BsjSetDriverDetectionModal
